import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Represents a view for the betting shop table.
 * @extends JetView
 */
export default class tableBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format for displaying dates
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;

        /**
         * Custom checkbox template for rendering action buttons.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common methods for rendering.
         * @param {string} value - The value determining the checkbox state.
         * @returns {string} HTML string for the checkbox representation.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'N') return '';
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>';
        }

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'datatable', // ID for the data table
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'CreatedDate', // Column ID for creation date
                                    header: _('Fecha de creación'), // Column header with localization
                                    width: 240, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                                        return obj.CreatedDate; // Return the creation date
                                    },
                                    format: dateFormat, // Format for displaying dates
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    sort: 'text', // Sorting type
                                },
                                {
                                    id: 'Action', // Column ID for action buttons
                                    header: '', // No header
                                    template: custom_checkbox, // Use custom checkbox template
                                    width: 100, // Column width
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail title
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        if (obj.$level == 1 || obj.$level == 2) {
                                            return ''; // No details for certain levels
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId', // Column ID for user ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                },
                                {
                                    id: 'Document', // Column ID for document number
                                    header: _('Número cédula'), // Column header with localization
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Login', // Column ID for login
                                    header: _('Login'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID for name
                                    header: _('Nombre'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AmountBetting', // Column ID for betting amount
                                    header: _('Saldo'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Format for displaying prices
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'RegionName', // Column ID for region name
                                    header: _('Región'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DepartmentName', // Column ID for department name
                                    header: _('Departamento'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CityName', // Column ID for city name
                                    header: _('Ciudad'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CurrencyId', // Column ID for currency
                                    header: _('Moneda'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Phone', // Column ID for phone number
                                    header: _('Teléfono'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Address', // Column ID for address
                                    header: _('Dirección'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: _('Dirección IP'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedDate', // Column ID for creation date (duplicate)
                                    header: _('Fecha de creación'), // Column header with localization
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    width: 180, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Format for displaying dates
                                },
                                {
                                    id: 'LastLoginDateLabel', // Column ID for last login date
                                    header: _('Fecha de ultimo login'), // Column header with localization
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    width: 180, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Format for displaying dates
                                },
                                {
                                    id: 'ModifiedLocal', // Column ID for modified status
                                    header: _('Modificado'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                /**
                                 * Event handler for clicking on the details icon.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked item.
                                 */
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('betShoop:select', [
                                        item, // Trigger select event with the item
                                    ]);
                                    if (vthis.getUrl()[0].page !== 'betShopManagement')
                                        vthis.show(
                                            'betShopManagement?user=' + id + '/betShopManagement.informationBetShop',
                                        );
                                    // Show bet shop management page
                                    else vthis.show('/betShopManagement.informationBetShop'); // Show information page
                                },
                                /**
                                 * Event handler for clicking the approve button.
                                 * @param {Event} ev - The event object.
                                 * @param {string} id - The ID of the clicked item.
                                 */
                                approbarbutton: function (ev, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    if (item.StateValidate == 'N') {
                                        const data = {
                                            Id: item.Id, // Prepare data for the API call
                                            Action: 'A', // Action to approve
                                        };
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Agent/SetStateValidate', // API endpoint
                                                data, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error'); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            webix.message({
                                                                type: 'error',
                                                                text: _('Ocurrio un error, comuniquese con soporte'), // Show error message
                                                            });
                                                        } else {
                                                            item.StateValidate = 'A'; // Update item state
                                                            item.Action = 'A'; // Update action
                                                            webix.message(
                                                                'Guardado', // Show success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            type: 'error',
                                            text: _(
                                                'No puedes activar un registro ya actualizado.', // Show error message
                                            ),
                                        });
                                    }
                                },
                                /**
                                 * Event handler for clicking the reject button.
                                 * @param {Event} ev - The event object.
                                 * @param {string} id - The ID of the clicked item.
                                 */
                                rechazarbutton: function (ev, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    if (item.StateValidate == 'N') {
                                        const data = {
                                            Id: item.Id, // Prepare data for the API call
                                            Action: 'I', // Action to reject
                                        };
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Agent/SetStateValidate', // API endpoint
                                                data, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            _('Error'), // Show error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            webix.message({
                                                                type: 'error',
                                                                text: _(
                                                                    'Ocurrio un error, comuniquese con soporte', // Show error message
                                                                ),
                                                            });
                                                        } else {
                                                            item.StateValidate = 'I'; // Update item state
                                                            item.Action = 'I'; // Update action
                                                            webix.message(
                                                                'Saved', // Show success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            type: 'error',
                                            text: _(
                                                'No puedes activar un registro ya actualizado.', // Show error message
                                            ),
                                        });
                                    }
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // ID for the pager
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component with the 'datatable' ID
        grid = $$('datatable');

        // Construct the API URL for fetching bet shops
        var url = devConfig.geturlApi() + 'BetShop/GetBetShops';

        // Initialize an empty filter string
        var filter = '';

        // Attach an event handler for the 'onAfterLoad' event of the grid
        grid.attachEvent('onAfterLoad', function () {
            // Group data in the grid by country, displaying country flags
            $$('datatable').data.group({
                by: function (obj) {
                    return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country;
                },
                map: {
                    Partner: ['Partner'],
                    flag: ['flag'],
                    Country: ['Country'],
                    AmountBetting: ['AmountBetting', 'sum'],
                },
            });

            // Group data in the grid by partner
            $$('datatable').data.group({
                by: function (obj) {
                    return "<i class='partner " + obj.Partner + "'></i>";
                },
                map: {
                    Partner: ['Partner'],
                    Country: [''],
                    AmountBetting: ['AmountBetting', 'sum'],
                },
            });
        });

        // Listen for the 'betShop:filter' event to apply filters to the grid
        this.on(this.app, 'betShop:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string for date filters
            var string2 = ''; // Initialize query string for sorting

            // Iterate over each filter entry
            for (var i = 0; i < object.length; i++) {
                // Handle sorting based on the 'Sort' key
                if (object[i][0] == 'Sort') {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[CreatedDate]=';
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[Id]=';
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Login]=';
                            } else {
                                if (object[i][1] == '4') {
                                    string2 = string2 + '&sort[Name]=';
                                }
                            }
                        }
                    }
                }
                // Handle sorting direction based on the 'Dir' key
                if (object[i][0] == 'Dir') {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc';
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc';
                        }
                    }
                }
                // Handle other filter types
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date); // Log the date range for debugging
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'Date') {
                            var date = object[i][1].replace(' 00:00:00', '');
                            string1 = string1 + '&dateFrom=' + date;
                            string1 = string1 + '&dateTo=' + date;
                        } else {
                            if (object[i][0] != 'Sort' && object[i][0] != 'Dir') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                            }
                        }
                    }
                } else {
                    // Handle nested filter objects
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear existing data in the grid
            grid.clearAll();

            // Load new data into the grid with the constructed URL and filters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1 + string2);

            // Update the filter variable with the current filters
            filter = string1 + string2;

            // Hide the filter popup after applying filters
            $$('filterPopup').hide();
        });

        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load sorted data into the grid based on the selected sort criteria
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Listen for the 'player:select' event to filter data by player ID
        this.on(this.app, 'player:select', (Id) => {
            // Load data into the grid filtered by the selected player ID
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
